import { Map } from 'immutable';
/**
 * User state
 *
 * @export
 * @class UserState
 */
var UserState = /** @class */ (function () {
    function UserState() {
        /**
         * The list of users information
         */
        this.info = Map({});
        /**
         * If users profile are loaded
         */
        this.loaded = false;
        /**
         * If edit profile is open {true} or not {false}
         */
        this.openEditProfile = false;
        /**
         * People data storage
         */
        this.people = Map({ hasMoreData: true, lastPageRequest: -1, lastUserId: '' });
    }
    return UserState;
}());
export { UserState };



//////////////////
// WEBPACK FOOTER
// ./src/store/reducers/users/UserState.ts
// module id = 573
// module chunks = 50